
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.92 15.553"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 492","d":"M22.757 13.041L12.073 2.401 2.339 13.387","fill":"none","stroke":"#184683","stroke-linecap":"round","stroke-width":"3.00042"}})])
          )
        }
      }
    